module.exports = __webpack_public_path__ + "img/next_btn.9dc0159e.png";